import Breadcrumbs from "components/Common/Breadcrumb"
import ConfigUrl, { axiosbaseurl } from "../../config"
import React, { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Container } from "reactstrap"
import { IoMdWarning } from "react-icons/io"
import { SiTicktick } from "react-icons/si"
import { notification } from "antd"
import Loader from "pages/Loader"
import PermittedComponent from "PermittedComponent"
import { usePermissionData } from "AppContext"
import { FaChevronLeft, FaSave } from "react-icons/fa"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"
import WindowedSelect from "react-windowed-select"

const AddTip = () => {
  document.title = "News & Update | Return First Investments"

  const { checkAccess } = usePermissionData()

  const navigate = useNavigate()

  const [Loading, setLoading] = useState(false)
  const [stocks, setstocks] = useState([])

  useEffect(() => {
    getdata()
  }, [])

  const getdata = async () => {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`stocks/list`)
      setLoading(false)
      if (response?.data?.success) {
        setstocks(
          response.data.data.map(item => {
            return { value: item.Symbol, label: item.Name }
          })
        )
      }
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const [errors, setErrors] = useState({})

  // Form state
  const [tipData, setTipData] = useState({
    newsTitle: "",
    stockName: "",
    Symbol: "",
    tradeType: "0", // 0 = Not selected, 1 = Equity, 2 = Intraday, 3 = Options
    recommendation: "buy", // Buy or Sell (Only for Equity)
    risk: "low", // Risk: low, medium, high
    buyPrice: "",
    sellPrice: "",
    stopLoss: "",
    newsDateAndTime: "",
    newsDescription: "",
  })

  // Handle input change
  const handleChange = e => {
    const { name, value } = e.target

    // Find the full stock object
    if (name === "stockName") {
      const selectedStock = stocks.find(item => item.Symbol === value)

      setTipData(prev => ({
        ...prev,
        stockName: value,
        Symbol: selectedStock?.Symbol || "",
      }))
    } else {
      setTipData(prev => ({
        ...prev,
        [name]: value,
      }))
    }
  }

  const validate = () => {
    let newErrors = {}
    const { newsTitle, stockName } = tipData

    if (!newsTitle.trim()) newErrors.newsTitle = "Tip Title is required"
    if (!stockName.trim()) newErrors.stockName = "Stock Name is required"
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async () => {
    if (validate()) {
      try {
        setLoading(true)

        const response = await axiosbaseurl.post(`news/update`, tipData)

        if (response?.data?.success) {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex align-items-center">
                <div className="pr-20">
                  <SiTicktick className="text-success fs-4 me-2" />
                </div>
                <div className="succes-message">News Created Successfully.</div>
              </div>
            ),
            placement: "topRight",
          })

          setTimeout(() => {
            navigate(`${ConfigUrl.appurl}tips`)
          }, 1000)
        } else {
          setLoading(false)
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <IoMdWarning className="text-danger" size={22} />
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
          })
        }
      } catch (e) {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
          description: e?.response?.data?.message,
        })
      }
    }
  }

  const renderError = field =>
    errors[field] && <div className="text-danger">{errors[field]}</div>

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(2, 2)}>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="News & Update"
              breadcrumbItem="Add News & Update"
            />

            <div className="card p-3">
              <div className="text-end">
                <button
                  className="btn edit-Button bg-success text-white me-3 rounded-5"
                  onClick={handleSubmit}
                >
                  <FaSave className="me-2" />
                  Submit
                </button>
                <button
                  className="btn delete-Button rounded-5"
                  onClick={() => navigate(-1)}
                >
                  <FaChevronLeft className="me-2" />
                  Back
                </button>
              </div>
              <div className="Line" />

              <div className="row my-3">
                <div className="form-group col-xl-6">
                  <label>
                    News Title <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control`}
                    name="newsTitle"
                    placeholder="Enter news title"
                    value={tipData.newsTitle}
                    onChange={handleChange}
                  />
                  {renderError("newsTitle")}
                </div>

                <div className="col-xl-6">
                  <label>
                    Stock Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    value={tipData?.stockName}
                    className="form-control"
                    onChange={e =>
                      setTipData(prev => ({
                        ...prev,
                        stockName: e.target.value || "",
                      }))
                    }
                  />
                </div>

                <div className="col-xl-6 mt-3">
                  <label>News Date & Time</label>
                  <input
                    type="datetime-local"
                    className={`form-control`}
                    name="newsDateAndTime"
                    value={tipData.newsDateAndTime}
                    onChange={handleChange}
                  />
                  {renderError("newsDateAndTime")}
                </div>

                <div className="col-xl-12 mt-3 mb-4">
                  <label>News Description</label>
                  <ReactQuill
                    style={{ height: "150px" }}
                    theme="snow"
                    name="newsDescription"
                    value={tipData?.newsDescription}
                    onChange={value =>
                      handleChange({
                        target: { name: "newsDescription", value },
                      })
                    }
                    placeholder="Write something amazing..."
                  />
                </div>
              </div>
            </div>
          </Container>
        </div>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default AddTip
